import React, { useState } from "react";
import ImgWrapper from "../ImgWrapper";
import Spacer from "../Spacer";
import chevronDownWhite from "assets/icons/chevronDownWhite.svg";
import { NavLink, useLocation } from "react-router-dom";
import DropDownLink from "./DropDownLink";
import PostIcon from "assets/icons/post-Icon-new.svg";
import AiIcon from "assets/icons/ai-Icon-new.svg";
import calendarIcon from "assets/icons/calendar-lightGrey.svg";
import annotationIcon from "assets/icons/annotationIcon-light.svg";
import DmIcon from "assets/icons/dm-Icon.svg";
import CommentIcon from "assets/icons/commentIcon.svg";
import AccountIcon from "assets/icons/analyticAccountIcon.svg";
import ContentIcon from "assets/icons/analyticContentIcon.svg";
import UserIcon from "assets/icons/userIcon-light.svg";
import UserGroup from "assets/icons/userGroupIcon-light.svg";
import OfficeIcon from "assets/icons/officeIcon-light.svg";
import Cancel from "assets/icons/cancelWhite.svg";
import {
  ArrowWrapper,
  BottomSection,
  Wrapper,
  Menu,
  WorkspaceContainer,
  WorkspaceMenu,
  Brands,
} from "./SidebarStyle";
import DropdownList from "./DropdownList";
import { connect } from "react-redux";
import { getBrand, getMember, setBrandDetails } from "api";
import { useEffect } from "react";
import useSwitchWorkspace from "hooks/useSwitchWorkspace";
import { useCallback } from "react";

const Sidebar = ({
  user,
  user_accounts,
  active_account,
  brands,
  brand,
  setBrandDetails,
  dms_badge,
  comments_badge,
}) => {
  const location = useLocation();
  const [showDropdownList, setShowDropdownList] = useState({
    brands: false,
    workspaces: false,
  });

  const { saveAccountId } = useSwitchWorkspace(
    active_account,
    user_accounts,
    setBrandDetails
  );

  const handleSelectBrand = useCallback(
    (brand) => {
      setBrandDetails(brand);
      getBrand(brand?.id);
      getMember(); // set member access
    },
    [setBrandDetails]
  );

  useEffect(() => {
    // set active brand to the first brand when user has no active brand selected
    if (!brand && brands?.length > 0) {
      handleSelectBrand(brands[0]);
    }
  }, [brand, brands, handleSelectBrand]);

  useEffect(() => {
    document.querySelector(".sidebar").classList.remove("open");
  }, [location]);

  return (
    <Wrapper className="sidebar">
      <div className="logo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="24"
          viewBox="0 0 18 24"
          fill="none"
        >
          <g clipPath="url(#clip0_22128_11420)">
            <path
              opacity="0.96"
              d="M7.82661 14.162L2.06579 14.384C1.71664 14.3968 1.3703 14.3164 1.0615 14.1511C0.752698 13.9857 0.492281 13.7412 0.306341 13.442C0.120403 13.1428 0.015476 12.7994 0.00207703 12.4462C-0.011322 12.0931 0.0672772 11.7425 0.229998 11.4298L2.91649 6.2702L5.61436 1.11478C5.77758 0.801925 6.01936 0.538064 6.31539 0.349736C6.61142 0.161408 6.95126 0.0552548 7.30071 0.0419524C7.65017 0.02865 7.99693 0.108668 8.30611 0.273958C8.61529 0.439247 8.87599 0.683981 9.062 0.983541L12.1308 5.91936L15.1993 10.8568C15.3854 11.1563 15.4903 11.5 15.5035 11.8534C15.5166 12.2068 15.4376 12.5576 15.2743 12.8703C15.111 13.183 14.869 13.4467 14.5729 13.6349C14.277 13.8231 13.9372 13.9291 13.5877 13.9423L7.82661 14.162Z"
              fill="#149DFF"
            />
            <path
              opacity="0.87"
              d="M9.88226 9.74307L15.645 9.53622C15.9936 9.52474 16.3391 9.60607 16.6468 9.77206C16.9546 9.93807 17.2138 10.1829 17.3986 10.4821C17.5835 10.7813 17.6873 11.1243 17.7 11.4769C17.7126 11.8295 17.6334 12.1792 17.4704 12.4911L14.7707 17.6464L12.069 22.7963C11.9049 23.1089 11.6623 23.3722 11.3657 23.5597C11.0691 23.7474 10.7289 23.8527 10.3793 23.8653C10.0297 23.8778 9.683 23.7971 9.37401 23.6312C9.06503 23.4652 8.80465 23.22 8.61904 22.92L5.56157 17.9765L2.50411 13.0334C2.31821 12.7336 2.21368 12.3896 2.20101 12.0359C2.18835 11.6823 2.26801 11.3315 2.43196 11.0189C2.59593 10.7063 2.8384 10.4429 3.135 10.2552C3.43158 10.0675 3.7718 9.96216 4.12144 9.94977L9.88226 9.74307Z"
              fill="#149DFF"
            />
          </g>
          <defs>
            <clipPath id="clip0_22128_11420">
              <rect width="17.8286" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="88"
          height="17"
          viewBox="0 0 88 17"
          fill="none"
        >
          <path
            d="M0.186401 0.277344H5.3776C6.7552 0.277344 7.808 0.596544 8.536 1.23494C9.264 1.86214 9.628 2.76934 9.628 3.95654C9.628 5.16614 9.264 6.09014 8.536 6.72854C7.808 7.36694 6.7552 7.68614 5.3776 7.68614H2.2696V12.8773H0.186401V0.277344ZM5.2936 5.72054C6.1224 5.72054 6.7048 5.59174 7.0408 5.33414C7.388 5.06534 7.5616 4.61734 7.5616 3.99014C7.5616 3.35174 7.3936 2.90374 7.0576 2.64614C6.7216 2.37734 6.1336 2.24294 5.2936 2.24294H2.2696V5.72054H5.2936Z"
            fill="white"
          />
          <path
            d="M14.8321 3.72134C15.7505 3.72134 16.5737 3.92294 17.3017 4.32614C18.0409 4.71814 18.6177 5.27254 19.0321 5.98934C19.4353 6.67254 19.6369 7.47894 19.6369 8.40854C19.6369 9.30454 19.4297 10.1109 19.0153 10.8277C18.6121 11.5445 18.0465 12.0989 17.3185 12.4909C16.5905 12.8829 15.7617 13.0789 14.8321 13.0789C13.9025 13.0789 13.0681 12.8829 12.3289 12.4909C11.6009 12.0989 11.0353 11.5445 10.6321 10.8277C10.2289 10.1333 10.0273 9.32694 10.0273 8.40854C10.0273 7.51254 10.2289 6.70614 10.6321 5.98934C11.0465 5.27254 11.6233 4.71254 12.3625 4.30934C13.0793 3.91734 13.9025 3.72134 14.8321 3.72134ZM17.5537 8.40854C17.5537 7.56854 17.3073 6.90214 16.8145 6.40934C16.3217 5.90534 15.6609 5.65334 14.8321 5.65334C14.0033 5.65334 13.3425 5.90534 12.8497 6.40934C12.3569 6.90214 12.1105 7.56854 12.1105 8.40854C12.1105 9.24854 12.3569 9.91494 12.8497 10.4077C13.3425 10.9005 14.0033 11.1469 14.8321 11.1469C15.6609 11.1469 16.3217 10.9005 16.8145 10.4077C17.3073 9.91494 17.5537 9.24854 17.5537 8.40854Z"
            fill="white"
          />
          <path
            d="M24.2248 13.0789C23.284 13.0789 22.2816 12.8605 21.2176 12.4237L20.596 12.1717L20.4448 11.9365V9.90374L21.2008 10.2733C21.8616 10.6093 22.3992 10.8389 22.8136 10.9621C23.228 11.0853 23.6872 11.1469 24.1912 11.1469C24.8632 11.1469 25.3336 11.0797 25.6024 10.9453C25.8712 10.8221 26.0056 10.5981 26.0056 10.2733C26.0056 10.1277 25.972 10.0101 25.9048 9.92054C25.8488 9.83094 25.7536 9.74694 25.6192 9.66854L25.636 9.68534C25.3112 9.51734 24.7792 9.35494 24.04 9.19814C23.2224 9.01894 22.6064 8.83974 22.192 8.66054C21.7888 8.48134 21.4416 8.22934 21.1504 7.90454C20.8032 7.54614 20.6296 7.04214 20.6296 6.39254C20.6296 4.61174 21.856 3.72134 24.3088 3.72134C24.8464 3.72134 25.3392 3.78294 25.7872 3.90614C26.2352 4.01814 26.868 4.24214 27.6856 4.57814V6.67814L26.8456 6.34214C26.252 6.08454 25.7704 5.90534 25.4008 5.80454C25.0424 5.70374 24.6952 5.65334 24.3592 5.65334C23.7096 5.65334 23.2728 5.70934 23.0488 5.82134C22.8136 5.93334 22.696 6.13494 22.696 6.42614C22.696 6.76214 23.0208 7.00294 23.6704 7.14854L24.8464 7.45094C25.776 7.70854 26.4256 7.92694 26.7952 8.10614C27.176 8.27414 27.4784 8.51494 27.7024 8.82854C27.96 9.22054 28.0888 9.70774 28.0888 10.2901C28.0888 11.1413 27.736 11.8189 27.0304 12.3229C26.3248 12.8269 25.3896 13.0789 24.2248 13.0789Z"
            fill="white"
          />
          <path
            d="M30.3897 5.83814H28.4745L28.4577 3.93974H30.3729L30.3225 1.43654L32.3721 1.41974L32.4225 3.92294L35.0769 3.93974L35.0937 5.83814L32.4393 5.82134L32.3721 9.87014C32.3609 10.2397 32.4169 10.5141 32.5401 10.6933C32.6745 10.8613 32.8817 10.9453 33.1617 10.9453C33.6769 10.9453 34.3489 10.7381 35.1777 10.3237L35.4297 12.2221C35.0937 12.4461 34.7297 12.6197 34.3377 12.7429C33.9569 12.8773 33.5649 12.9445 33.1617 12.9445C32.3329 12.9445 31.6609 12.7093 31.1457 12.2389C30.6305 11.7685 30.3729 11.1525 30.3729 10.3909L30.3897 5.83814Z"
            fill="white"
          />
          <path
            d="M36.9364 0.277344H42.1276C43.5052 0.277344 44.558 0.596544 45.286 1.23494C46.014 1.86214 46.378 2.76934 46.378 3.95654C46.378 5.16614 46.014 6.09014 45.286 6.72854C44.558 7.36694 43.5052 7.68614 42.1276 7.68614H39.0196V12.8773H36.9364V0.277344ZM42.0436 5.72054C42.8724 5.72054 43.4548 5.59174 43.7908 5.33414C44.138 5.06534 44.3116 4.61734 44.3116 3.99014C44.3116 3.35174 44.1436 2.90374 43.8076 2.64614C43.4716 2.37734 42.8836 2.24294 42.0436 2.24294H39.0196V5.72054H42.0436Z"
            fill="white"
          />
          <path
            d="M46.8569 9.97094C46.8569 9.44454 46.9409 9.00214 47.1089 8.64374C47.2881 8.28534 47.5737 7.96054 47.9657 7.66934C48.6937 7.13174 49.5729 6.86294 50.6033 6.86294C51.1521 6.86294 51.6225 6.90214 52.0145 6.98054C52.4177 7.04774 52.7817 7.15974 53.1065 7.31654V7.26614C53.1065 6.77334 53.0449 6.41494 52.9217 6.19094C52.8097 5.95574 52.6081 5.79334 52.3169 5.70374C52.0145 5.60294 51.5273 5.55254 50.8553 5.55254C50.1609 5.55254 49.5785 5.67574 49.1081 5.92214C48.6489 6.15734 48.2065 6.56614 47.7809 7.14854V4.67894C48.1841 4.30934 48.6489 4.04054 49.1753 3.87254C49.7017 3.70454 50.3457 3.62054 51.1073 3.62054C52.4961 3.62054 53.5153 3.90614 54.1649 4.47734C54.8257 5.04854 55.1561 5.93894 55.1561 7.14854L55.1729 9.85334V12.9109H53.1233V12.3901C52.7985 12.6365 52.4177 12.8101 51.9809 12.9109C51.5441 13.0229 51.0065 13.0789 50.3681 13.0789C49.4609 13.0789 48.6433 12.8157 47.9153 12.2893C47.2097 11.7181 46.8569 10.9453 46.8569 9.97094ZM48.9065 9.90374C48.9065 10.2957 49.0633 10.6037 49.3769 10.8277C49.6905 11.0405 50.1329 11.1469 50.7041 11.1469C51.8353 11.1469 52.6361 10.7941 53.1065 10.0885V9.28214C52.8265 9.06934 52.5185 8.91814 52.1825 8.82854C51.8465 8.73894 51.4153 8.69414 50.8889 8.69414C50.1945 8.69414 49.6905 8.78934 49.3769 8.97974C49.0633 9.17014 48.9065 9.47814 48.9065 9.90374Z"
            fill="white"
          />
          <path
            d="M66.2903 12.8773H64.2407V12.1381C63.4791 12.7317 62.5719 13.0285 61.5191 13.0285C60.6119 13.0285 59.8167 12.8381 59.1335 12.4573C58.4503 12.0765 57.9295 11.5277 57.5711 10.8109C57.2015 10.1389 57.0167 9.32134 57.0167 8.35814C57.0167 7.45094 57.2071 6.63894 57.5879 5.92214C57.9687 5.20534 58.5007 4.65094 59.1839 4.25894C59.8783 3.86694 60.6567 3.67094 61.5191 3.67094C62.5719 3.67094 63.4791 3.96774 64.2407 4.56134V0.277344H66.2903V12.8773ZM64.2407 7.09814C64.0279 6.65014 63.6975 6.29174 63.2495 6.02294C62.8015 5.74294 62.3199 5.60294 61.8047 5.60294C60.9871 5.60294 60.3319 5.85494 59.8391 6.35894C59.3463 6.86294 59.0999 7.52934 59.0999 8.35814C59.0999 9.23174 59.3351 9.90934 59.8055 10.3909C60.2759 10.8613 60.9423 11.0965 61.8047 11.0965C62.3087 11.0965 62.7847 10.9565 63.2327 10.6765C63.6807 10.3965 64.0167 10.0325 64.2407 9.58454V7.09814Z"
            fill="white"
          />
          <path
            d="M76.9872 12.8773H74.9376V12.1381C74.176 12.7317 73.2688 13.0285 72.216 13.0285C71.3088 13.0285 70.5136 12.8381 69.8304 12.4573C69.1472 12.0765 68.6264 11.5277 68.268 10.8109C67.8984 10.1389 67.7136 9.32134 67.7136 8.35814C67.7136 7.45094 67.904 6.63894 68.2848 5.92214C68.6656 5.20534 69.1976 4.65094 69.8808 4.25894C70.5752 3.86694 71.3536 3.67094 72.216 3.67094C73.2688 3.67094 74.176 3.96774 74.9376 4.56134V0.277344H76.9872V12.8773ZM74.9376 7.09814C74.7248 6.65014 74.3944 6.29174 73.9464 6.02294C73.4984 5.74294 73.0168 5.60294 72.5016 5.60294C71.684 5.60294 71.0288 5.85494 70.536 6.35894C70.0432 6.86294 69.7968 7.52934 69.7968 8.35814C69.7968 9.23174 70.032 9.90934 70.5024 10.3909C70.9728 10.8613 71.6392 11.0965 72.5016 11.0965C73.0056 11.0965 73.4816 10.9565 73.9296 10.6765C74.3776 10.3965 74.7136 10.0325 74.9376 9.58454V7.09814Z"
            fill="white"
          />
          <path
            d="M78.4441 14.1373C78.9817 14.3053 79.4241 14.3893 79.7713 14.3893C80.2641 14.3893 80.6785 14.2269 81.0145 13.9021C81.3617 13.5885 81.6809 13.0621 81.9721 12.3229L78.1081 3.92294H80.3761L83.0137 9.83654L85.4833 3.92294H87.7177L83.4505 13.7005C83.0921 14.5181 82.5825 15.1621 81.9217 15.6325C81.2609 16.1029 80.5273 16.3381 79.7209 16.3381C79.2953 16.3381 78.8697 16.2709 78.4441 16.1365V14.1373Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="top-section">
        <Brands>
          <div className="brand-tour">
            <header className="brands-header">BRANDS</header>
            <button
              onClick={() =>
                document.querySelector(".sidebar").classList.remove("open")
              }
              className="close-icon"
            >
              <img src={Cancel} alt="cancel" />
            </button>
          </div>
          <Spacer y={0.6} />
          <div
            className="brands-dropdown"
            onClick={() => {
              if (brands?.length > 1) {
                setShowDropdownList((prev) => ({
                  ...prev,
                  brands: !prev.brands,
                }));
              }
            }}
          >
            <ImgWrapper size={2.0} imgHeight={"100%"}>
              {brand?.avatar ? (
                <img src={brand?.avatar} alt="user" />
              ) : (
                <img src={UserIcon} alt="user" />
              )}
            </ImgWrapper>
            {brand ? (
              <>
                <h5 className="ellipsify brand-name">{brand?.name}</h5>
                {brands.length > 1 && (
                  <ArrowWrapper>
                    <img
                      src={chevronDownWhite}
                      alt="down"
                      className="arrowDown"
                    />
                  </ArrowWrapper>
                )}
              </>
            ) : null}
          </div>
        </Brands>
        {showDropdownList.brands && (
          <DropdownList
            setShowDropdownList={setShowDropdownList}
            title="List of Brands"
            top
            list={brands}
            defaultSelected={brand}
            callback={handleSelectBrand}
            lastListElementRef={null}
          />
        )}

        <Menu>
          <ul>
            <li className="dropdown-li">
              <DropDownLink title="publishing">
                <NavLink to="/dashboard/posts">
                  <div className="linkGroup">
                    <img src={PostIcon} alt="posts" className="icon" />
                    Posts
                  </div>
                </NavLink>
                <NavLink to="/dashboard/ai-assistant">
                  <div className="linkGroup">
                    <img src={AiIcon} alt="ai" className="ai" />
                    AI Assistant
                  </div>
                </NavLink>
                <NavLink to="/dashboard/calendar">
                  <div className="linkGroup">
                    <img src={calendarIcon} alt="calendar" className="icon" />
                    Calendar
                  </div>
                </NavLink>
                <NavLink to="/dashboard/drafts">
                  <div className="linkGroup">
                    <img src={annotationIcon} alt="drafts" className="icon" />
                    Drafts
                  </div>
                </NavLink>
              </DropDownLink>
            </li>
            <li className="dropdown-li">
              <DropDownLink title="engagement">
                <NavLink to="/dashboard/direct-messages">
                  <div className="linkGroup">
                    <div className="image-with-dot">
                      {dms_badge && <div className="dot"></div>}
                      <img
                        src={DmIcon}
                        alt="direct messages"
                        className="icon"
                      />
                    </div>
                    <span className="flexRow">Private Messages</span>
                  </div>
                </NavLink>
                <NavLink to="/dashboard/comments">
                  <div className="linkGroup">
                    <div className="image-with-dot">
                      {comments_badge && <div className="dot"></div>}
                      <img src={CommentIcon} alt="comments" className="icon" />
                    </div>
                    <span className="flexRow">Comments</span>
                  </div>
                </NavLink>
              </DropDownLink>
            </li>
            <li className="dropdown-li">
              <DropDownLink title="analytics">
                <NavLink to="/dashboard/analytics/account">
                  <div className="linkGroup">
                    <img
                      src={AccountIcon}
                      alt="account analytics"
                      className="icon"
                    />
                    Account
                  </div>
                </NavLink>
                <NavLink to="/dashboard/analytics/content">
                  <div className="linkGroup">
                    <img
                      src={ContentIcon}
                      alt="content analytics"
                      className="icon"
                    />
                    Content
                  </div>
                </NavLink>
                <NavLink to="/dashboard/analytics/audience">
                  <div className="linkGroup">
                    <img
                      src={UserIcon}
                      alt="audience analytics"
                      className="icon"
                    />
                    Audience
                  </div>
                </NavLink>
              </DropDownLink>
            </li>
          </ul>
        </Menu>
      </div>

      <BottomSection>
        {showDropdownList.workspaces && (
          <DropdownList
            setShowDropdownList={setShowDropdownList}
            title="List of Workspaces"
            list={user_accounts}
            defaultSelected={active_account}
            callback={saveAccountId}
            isLoading={false}
            lastListElementRef={null}
            user={user}
            user_accounts={user_accounts}
          />
        )}
        <Spacer y={1.3} />
        <header className="workspace-header">WORKSPACES</header>
        <Spacer y={0.6} />

        {user_accounts?.length > 0 && (
          <WorkspaceContainer
            onClick={() =>
              setShowDropdownList((prev) => ({
                ...prev,
                workspaces: !prev.workspaces,
              }))
            }
            id="workspace-target-click" // for guided tour
          >
            <div className="workspaces flexRow">
              {active_account ? <div className="wrapper">
                <div className="workspace flexRow alignCenter justifyCenter">
                  <div className="image-with-dot">
                    
                      <div className="dot green-dot"></div>
                    
                    <ImgWrapper size={3.2} imgHeight={"100%"} className="imgWrapper">
                      {active_account?.avatar ? (
                        <img
                          src={active_account.avatar}
                          alt="brand"
                        />
                      ) : (
                        active_account.name?.slice(0, 1)
                      )}
                    </ImgWrapper>
                  </div>
                </div>
              </div> : null}
              {user_accounts?.filter(item => item.id !== active_account?.id).slice(0, 4).map((item) => (
                <div key={item.id} className="wrapper">
                  <div className="workspace flexRow alignCenter justifyCenter">
                    <div className="image-with-dot">
                      {active_account?.id === item.id && (
                        <div className="dot green-dot"></div>
                      )}
                      <ImgWrapper size={3.2} imgHeight={"100%"} className="imgWrapper">
                        {item.avatar ? (
                          <img
                            src={item?.avatar}
                            alt="brand"
                          />
                        ) : (
                          item.name?.slice(0, 1)
                        )}
                      </ImgWrapper>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <ArrowWrapper>
              <img
                src={chevronDownWhite}
                alt="angle down"
                className="arrow-icon"
              />
            </ArrowWrapper>
          </WorkspaceContainer>
        )}
        <Spacer y={2.4} />

        <WorkspaceMenu>
          <ul>
            <li className="menu-list">
              <NavLink to="/dashboard/brands">
                <div className="linkGroup">
                  <img src={OfficeIcon} alt="brands" className="icon" />
                  Brands
                </div>
              </NavLink>
            </li>
            <li className="menu-list">
              <NavLink to="/dashboard/team-members">
                <div className="linkGroup team-tour">
                  <img src={UserGroup} alt="team" className="icon" />
                  Team Members
                </div>
              </NavLink>
            </li>
          </ul>
        </WorkspaceMenu>
      </BottomSection>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    brand: state.brand,
    brands: state.brands,
    user: state.user,
    user_accounts: state.user_accounts,
    active_account: state.active_account,
    dms_badge: state.dms_badge,
    comments_badge: state.comments_badge
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBrandDetails: (data) => dispatch(setBrandDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
